import { configFetch as fetch } from '@laigu/utils';

const plans = { 1: 'free', 2: 'base', 3: 'pro', 4: 'ent', 9: 'flagship' };
// 获取企业版本信息
export const getPaymentApi = () => {
  return fetch({
    url: '/enterprise/plan',
    method: 'get'
  }).then(res => {
    const { data } = res;
    return {
      data: {
        ...data,
        ...{ plan: plans[data.plan] || 'free' }
      }
    };
  });
};
